export default __webpack_public_path__ + "static/media/me.188eb9f1.jpeg";